export const detectionsFr = {
    api: {
        error: {
            exportDetections: "Erreur pendant l'export des détections",
            fetchDetections: 'Erreur pendant la récupération des détections'
        },
        success: {
            exportDetections: 'Le fichier a bien été généré',
            fetchDetections: 'Détections correctement récupérées'
        }
    },
    actions: {},
    export: {
        allDetections: 'Toutes les détections',
        currentPage: 'Uniquement la page actuelle (Page {page})',
        device: 'Appareil'
    },
    filters: {
        bib: 'Bib',
        checkpoint: 'POI',
        startDate: 'A partir du',
        start_at: 'A partir du',
        end_at: "Jusqu'au",
        endDate: "Jusqu'au",
        device: 'Appareil',
        event: 'Évènement',
        siteId: 'Site ID',
        timerId: 'Timer ID',
        origin: 'Origine',
        destination: 'Destination',

        arrived_at_from: 'Arrivée à partir du',
        arrived_at_to: "Arrivée jusqu'au",
        left_at_from: 'Départ à partir du',
        left_at_to: "Départ jusqu'au"
    },
    model: {
        bib: 'Bib',
        poiId: 'POI',
        deviceId: "ID de l'appareil",
        eventFilter: "ID de l'évènement",
        id: 'ID',
        timerFilter: 'ID du chronométreur',
        timestamp: 'Date'
    },
    noDetectionFound: 'Aucune détection trouvée',
    table: {
        bib: 'Bib',
        poiName: 'POI',
        siteName: 'Site',
        detections: 'Détections',
        deviceId: "ID de l'appareil",
        deviceName: "Nom de l'appareil",
        eventFilter: "ID de l'évènement",
        id: 'ID',
        timerFilter: 'ID du chronométreur',
        timestamp: 'Date',

        origin_poi: 'Point de départ',
        origin_name: "POI d'origine",
        destination_name: 'POI de destination',
        destination_poi: "Point d'arrivée",
        epc: 'EPC',
        epc_type: "Type d'EPC",
        start_at: 'Départ à',
        end_at: 'Arrivé à',

        arrived_at_origin: 'Arrivé à (POI origine)',
        arrived_at_destination: 'Arrivé à (POI destination)',

        poi_id: 'ID',
        poi_name: 'POI',
        arrived_at: 'Arrivé à',
        left_at: 'Départ à',
        duration: 'Durée',
        status: 'Status'
    }
}
